import React from 'react';
import { Create, SimpleForm, TextInput, FileInput, ImageField, useCreate, useNotify, useRedirect, required } from 'react-admin';
import { uploadImage } from '../../../config/services/strapi/strapi';

function TarjetasInicioCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-tarjetas-inicios';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const payload: Record<string, any> = { titulo: data.titulo };

      // Subir Portada si existe
      if (data.portada?.rawFile) {
        const uploaded = await uploadImage(data.portada.rawFile, token!);
        payload.portada = { id: uploaded.id };
      }

      // Subir Video si existe
      if (data.video?.rawFile) {
        const uploaded = await uploadImage(data.video.rawFile, token!);
        payload.video = { id: uploaded.id };
      }

      create(resourceName, { data: payload }, {
        onSuccess: () => {
          notify('Tarjeta creada', { type: 'success' });
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al subir archivos', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="titulo" label="Título" validate={[required()]} fullWidth />
        
        <FileInput source="portada" label="Portada (Imagen o Video)">
          <ImageField source="src" title="title" />
        </FileInput>

        <FileInput source="video" label="Video Principal">
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default TarjetasInicioCreate;